export default __webpack_public_path__ + "static/media/normal.b5b3dc74.svg";